import { Tag } from 'antd';
import { CalendarOutlined, ClockCircleOutlined, EyeOutlined, ScheduleOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { assignmentCardStyle, CardSupportText, CardTitle, getColor, getSize, AssignmentActionButton } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AssignmentCard = styled.article.withConfig({
  displayName: "class-assignment-itemcomponent__AssignmentCard",
  componentId: "sc-1vf4lcn-0"
})(["", " flex-wrap:wrap;gap:", ";.assignment-main{flex:1;min-width:0;display:flex;flex-direction:column;gap:", ";}.assignment-timing{display:flex;align-items:center;flex:0 0 100%;overflow-x:auto;gap:", ";.assignment-detail{flex-shrink:0;white-space:nowrap;}}.assignment-tags{display:flex;align-items:center;flex-wrap:wrap;gap:", ";.ant-tag{margin-right:0;}}.assignment-detail{display:flex;align-items:center;gap:", ";font-size:", ";color:", ";.anticon{font-size:", ";}}.assignment-actions{display:flex;flex-direction:column;align-items:stretch;gap:", ";flex-shrink:0;min-width:100px;}.assignment-submission{display:flex;align-items:center;gap:", ";flex-shrink:0;text-align:center;.ant-tag{margin-right:0;}}.submission-stat{display:flex;flex-direction:column;align-items:center;gap:", ";min-width:100px;}.submitted-label{font-weight:bold;letter-spacing:0.08em;text-transform:uppercase;font-size:", ";color:", ";margin-top:", ";}&.assignment-reference{position:relative;.assignment-main{padding-right:calc(100px + ", ");}.assignment-actions{position:absolute;right:", ";top:50%;transform:translateY(-50%);}}@media (max-width:650px){flex-wrap:wrap;.assignment-main{flex-basis:100%;}.assignment-actions{margin-left:auto;}.assignment-submission{flex-wrap:wrap;flex-shrink:1;}.submission-stat{min-width:0;}}"], assignmentCardStyle, getSize('padding16'), getSize('padding8'), getSize('padding12'), getSize('padding8'), getSize('padding8'), getSize('typo14'), getColor('textIntSub'), getSize('typo16'), getSize('padding12'), getSize('padding16'), getSize('padding8'), getSize('typo12'), getColor('textIntSub'), getSize('padding4'), getSize('padding16'), getSize('padding16'));
export var ClassAssignmentItem = function ClassAssignmentItem(_ref) {
  var title = _ref.title,
      status = _ref.status,
      statusColor = _ref.statusColor,
      statusNode = _ref.statusNode,
      typeTag = _ref.typeTag,
      countdown = _ref.countdown,
      duration = _ref.duration,
      startTime = _ref.startTime,
      endTime = _ref.endTime,
      locale = _ref.locale,
      labels = _ref.labels,
      submission = _ref.submission,
      onView = _ref.onView,
      viewLabel = _ref.viewLabel,
      _ref$timingKnown = _ref.timingKnown,
      timingKnown = _ref$timingKnown === void 0 ? true : _ref$timingKnown,
      _ref$showDuration = _ref.showDuration,
      showDuration = _ref$showDuration === void 0 ? true : _ref$showDuration,
      href = _ref.href,
      variant = _ref.variant;

  var date = function date(value) {
    if (!value) return timingKnown ? labels.notScheduled : '—';
    var timestamp = Number(value) * 1000;
    return Number.isFinite(timestamp) ? new Date(timestamp).toLocaleString(locale) : '—';
  };

  return /*#__PURE__*/_jsxs(AssignmentCard, {
    className: variant === 'reference' ? 'assignment-reference' : undefined,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "assignment-main",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "assignment-tags",
        children: [typeTag, statusNode || /*#__PURE__*/_jsx(Tag, {
          color: statusColor,
          style: {
            width: 'fit-content'
          },
          children: status
        }), countdown]
      }), /*#__PURE__*/_jsx(CardTitle, {
        children: title
      }), showDuration && /*#__PURE__*/_jsxs("div", {
        className: "assignment-detail",
        children: [/*#__PURE__*/_jsx(ClockCircleOutlined, {}), /*#__PURE__*/_jsxs("span", {
          children: [labels.duration, ":", ' ', duration ? "".concat(duration, " ").concat(labels.minutes) : timingKnown ? labels.noTimeLimit : '—']
        })]
      })]
    }), submission && /*#__PURE__*/_jsx("div", {
      className: "assignment-submission",
      children: submission
    }), /*#__PURE__*/_jsx("div", {
      className: "assignment-actions",
      children: /*#__PURE__*/_jsxs(AssignmentActionButton, {
        onClick: onView || (href ? function () {
          return window.location.assign(href);
        } : undefined),
        children: [/*#__PURE__*/_jsx(EyeOutlined, {}), viewLabel || labels.view]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "assignment-timing",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "assignment-detail",
        children: [/*#__PURE__*/_jsx(CalendarOutlined, {}), /*#__PURE__*/_jsxs(CardSupportText, {
          children: [labels.startsAt, ": ", date(startTime)]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "assignment-detail",
        children: [/*#__PURE__*/_jsx(ScheduleOutlined, {}), /*#__PURE__*/_jsxs(CardSupportText, {
          children: [labels.endsAt, ": ", date(endTime)]
        })]
      })]
    })]
  });
};